/** The 24-hour WhatsApp window (D56), computed from the server's `windowOpenUntil` against the app clock. */
export const MINUTE = 60_000;
export const HOUR = 60 * MINUTE;

export type WindowState = { open: true; msLeft: number; label: string } | { open: false; msLeft: 0; label: string };

/** Open while `now < windowOpenUntil`. "Nh to reply" (floored) from one hour up, "Nm to reply" under an hour. */
export function windowState(windowOpenUntil: number | null | undefined, now: number): WindowState {
  if (windowOpenUntil == null || now >= windowOpenUntil) return { open: false, msLeft: 0, label: "Template only" };
  const msLeft = windowOpenUntil - now;
  const label = msLeft >= HOUR ? `${Math.floor(msLeft / HOUR)}h to reply` : `${Math.max(1, Math.ceil(msLeft / MINUTE))}m to reply`;
  return { open: true, msLeft, label };
}
